var _path, _path2, _line, _line2, _line3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExamicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9984 2.10447V18.1981C19.9984 18.3432 19.9698 18.4868 19.9143 18.6208C19.8588 18.7548 19.7775 18.8765 19.6749 18.9791C19.5724 19.0817 19.4506 19.163 19.3166 19.2185C19.1826 19.274 19.039 19.3026 18.8939 19.3026H17.4739V4.83934C17.4739 4.54868 17.3594 4.26973 17.1551 4.06297C16.9508 3.85622 16.6732 3.73833 16.3826 3.73487H3.52344V2.10447C3.52685 1.8126 3.64431 1.53366 3.8507 1.32727C4.0571 1.12087 4.33604 1.00341 4.6279 1H18.8939C19.1858 1.00341 19.4647 1.12087 19.6711 1.32727C19.8775 1.53366 19.995 1.8126 19.9984 2.10447Z",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3705 3.73438H2.10447C1.49449 3.73438 1 4.22886 1 4.83884V20.9325C1 21.5425 1.49449 22.037 2.10447 22.037H16.3705C16.9805 22.037 17.475 21.5425 17.475 20.9325V4.83884C17.475 4.22886 16.9805 3.73438 16.3705 3.73438Z",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.85977,
    y1: 6.97422,
    x2: 10.9191,
    y2: 6.97422,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.22891,
    y1: 12.234,
    x2: 13.5476,
    y2: 12.234,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.22891,
    y1: 17.4937,
    x2: 8.28827,
    y2: 17.4937,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2031 16.7777L11.3719 18.0926L13.7094 15.4629",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamicon);
export default __webpack_public_path__ + "static/media/examicon.a4585666e6d2bc8362160120003d4a8b.svg";
export { ForwardRef as ReactComponent };